{
  "name": "bbo-ext",
  "version": "2.0.15",
  "scripts": {
    "ng": "ng",
    "prestart": "node aspnetcore-https",
    "start": "run-script-os",
    "start:mock": "ng serve -c=mock",
    "start:serviceworker": "ng build && http-server -p 8080 -c-1 dist",
    "start:windows": "ng serve --port 44420 --ssl --ssl-cert %APPDATA%\\ASP.NET\\https\\%npm_package_name%.pem --ssl-key %APPDATA%\\ASP.NET\\https\\%npm_package_name%.key",
    "start:default": "ng serve --port 44420 --ssl --ssl-cert $HOME/.aspnet/https/${npm_package_name}.pem --ssl-key $HOME/.aspnet/https/${npm_package_name}.key",
    "build:prod": "ng build",
    "build:test": "ng build --aot --c=test",
    "test": "ng test",
    "test:ci": "ng t --sourceMap=false --browsers=ChromeHeadless --watch=false",
    "lint": "ng lint",
    "watch": "ng build --watch --configuration development",
    "e2e": "ng e2e",
    "refreshVSToken": "vsts-npm-auth -config .npmrc"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.3",
    "@angular/cdk": "^18.2.3",
    "@angular/common": "^18.2.3",
    "@angular/compiler": "^18.2.3",
    "@angular/core": "^18.2.3",
    "@angular/forms": "^18.2.3",
    "@angular/material": "^18.2.3",
    "@angular/platform-browser": "^18.2.3",
    "@angular/platform-browser-dynamic": "^18.2.3",
    "@angular/pwa": "^0.803.29",
    "@angular/router": "^18.2.3",
    "@angular/service-worker": "^18.2.3",
    "@asfinag/atlas": "^18.0.1",
    "@asymmetrik/ngx-leaflet": "^18.0.0",
    "@asymmetrik/ngx-leaflet-markercluster": "^18.0.0",
    "@auth0/angular-jwt": "^5.1.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "ajv": "^8.8.2",
    "ajv-keywords": "^5.1.0",
    "dayjs": "^1.11.7",
    "leaflet": "^1.9.3",
    "leaflet.markercluster": "^1.5.3",
    "run-script-os": "^1.1.6",
    "rxjs": "^7.4.0",
    "rxjs-for-await": "^1.0.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.3",
    "@angular-eslint/builder": "^18.3.0",
    "@angular-eslint/eslint-plugin": "^18.3.0",
    "@angular-eslint/eslint-plugin-template": "^18.0.0",
    "@angular-eslint/schematics": "^18.3.0",
    "@angular-eslint/template-parser": "^18.3.0",
    "@angular/cli": "^18.2.3",
    "@angular/compiler-cli": "^18.2.3",
    "@schematics/angular": "^18.0.0",
    "@trivago/prettier-plugin-sort-imports": "^4.3.0",
    "@types/jasmine": "~4.3.1",
    "@types/leaflet": "^1.8.0",
    "@types/leaflet.markercluster": "^1.5.1",
    "@types/node": "^18.18.2",
    "@typescript-eslint/eslint-plugin": "7.2.0",
    "@typescript-eslint/parser": "7.2.0",
    "eslint": "^8.51.0",
    "eslint-config-prettier": "^9.1.0",
    "jasmine-core": "^5.1.1",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "prettier": "^3.2.5",
    "typescript": "^5.2.0"
  }
}
